import {success, failure, invalid} from "./helpers";

import {
  CREATE_ACCOUNT,
  GET_DEPARTMENT,
  GETINVITATIONBYCODE,
  REGISTER,
  UPLOAD
} from "../actions/CreateAccount";

const initialState = {
  ifRequestSuccess: false,
  all_state: [],
  department: [],
  get_invitation_by_code: {
    departments: [],
    states: [],
    timezones: []
  },
  error: '', // for register error
  successResponse: '',
  uploadSuccessResponse: '',
  uploadErrorMsg: '', // for upload error,
  // for error when inviation code is invalid
  invitation_error_message: ''
}

const create_account = (state=initialState, action) => {
  switch (action.type) {
    case CREATE_ACCOUNT:
      return {
        ...state
      }
    case success(GET_DEPARTMENT):
      return {
        ...state,
        department: action.payload
      }
    case success(GETINVITATIONBYCODE):
      return {
        ...state,
        get_invitation_by_code: action.payload
      }
    case invalid(GETINVITATIONBYCODE):
      return {
        ...state,
        invitation_error_message: action.payload.message
      }
    case success(REGISTER):
      return {
        ...state,
        ifRequestSuccess: true,
        error: '',
        successResponse: action.payload
      }
    case invalid(REGISTER):
      return {
        ...state,
        error: action.payload.message
      }
    case success(UPLOAD):
      return {
        ...state,
        uploadSuccessResponse: action.payload
      }
    case failure(UPLOAD):
      return {
        ...state,
        uploadErrorMsg: action.payload
      }
    default:
      return state;
  }
}

export default {
  create_account
};


// WEBPACK FOOTER //
// ./src/reducers/createAccount.js